  document.addEventListener('DOMContentLoaded', function() {
  
    // =======================================================
    // 1. Gallery, Lightbox & Explorer Initialization
    // =======================================================
    const initInterval = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(initInterval);
        initProductGallery();
        initMediaExplorer();
      }
    }, 100);
  
    function initProductGallery() {
      const gallery = document.querySelector('.gallery-container');
      const lightbox = document.getElementById('GalleryLightbox');
      if (!gallery || !lightbox) return;
      document.body.appendChild(lightbox);
      const thumbs = gallery.querySelectorAll('.thumb-item');
      const wrappers = gallery.querySelectorAll('.swiper-slide.media-wrapper');
  
      // 挂载为全局变量，供其他模块调用
      window.pdpMainSwiper = new Swiper('.main-swiper', {
        loop: false, speed: 400, spaceBetween: 0, grabCursor: true,
        navigation: { nextEl: '.main-nav-btn.next', prevEl: '.main-nav-btn.prev' },
        on: {
          slideChange: function () {
            thumbs.forEach(t => t.classList.remove('is-active'));
            if(thumbs[this.activeIndex]) {
              thumbs[this.activeIndex].classList.add('is-active');
              thumbs[this.activeIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
            wrappers.forEach((wrapper, index) => {
              const video = wrapper.querySelector('video');
              if (video) {
                if (index === this.activeIndex) { video.play(); } 
                else { video.pause(); }
              }
            });
          }
        }
      });
  
      const lightboxSwiper = new Swiper('.lightbox-swiper', {
        loop: false, speed: 400, spaceBetween: 20,
        navigation: { nextEl: '.lightbox-nav-btn.next', prevEl: '.lightbox-nav-btn.prev' }
      });
  
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', function() { window.pdpMainSwiper.slideTo(index); });
      });
  
      function openLightbox(index) {
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden'; 
        lightboxSwiper.slideTo(index, 0);
      }
  
      function closeLightbox() {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = ''; 
        lightbox.querySelectorAll('video').forEach(vid => vid.pause());
        lightbox.querySelectorAll('iframe').forEach(iframe => { iframe.src = iframe.src; });
      }
  
      wrappers.forEach((wrapper, index) => {
        wrapper.addEventListener('click', function(e) {
          if (e.target.closest('.interactive-media') || e.target.closest('.main-nav-btn')) return;
          openLightbox(index);
        });
      });
  
      const zoomBtn = gallery.querySelector('.zoom-indicator-btn');
      // 修复 Bug：同步修改为 window.pdpMainSwiper
      if (zoomBtn) { zoomBtn.addEventListener('click', () => { openLightbox(window.pdpMainSwiper.activeIndex); }); }
  
      const lbCloseBtn = lightbox.querySelector('.lightbox-close-btn');
      if (lbCloseBtn) lbCloseBtn.addEventListener('click', closeLightbox);
      
      lightbox.querySelector('.lightbox-swiper').addEventListener('click', function(e) {
        if (e.target.classList.contains('swiper-slide')) { closeLightbox(); }
      });
  
      gallery.querySelectorAll('.video-container').forEach(container => {
        const video = container.querySelector('video');
        const btn = container.querySelector('.btn-pause-play');
        if(video && btn) {
          btn.addEventListener('click', function(e) {
            e.stopPropagation(); e.preventDefault();
            if (video.paused) { video.play(); btn.innerText = 'Pause'; } 
            else { video.pause(); btn.innerText = 'Play'; }
          });
        }
      });
    }
  
    function initMediaExplorer() {
      const explorerOverlay = document.getElementById('V2MediaExplorer');
      if (!explorerOverlay) return;
      document.body.appendChild(explorerOverlay);
      
      const closeBtn = explorerOverlay.querySelector('.v2-exp-close');
      const triggerBtns = document.querySelectorAll('[data-exp-target]');
      const navLinks = explorerOverlay.querySelectorAll('[data-exp-link]');
      const panes = explorerOverlay.querySelectorAll('.exp-pane');
      const swiperInstances = {};
  
      panes.forEach(pane => {
        const swiperEl = pane.querySelector('.exp-main-swiper');
        if (!swiperEl) return;
        const targetID = pane.id.replace('exp-pane-', '');
        const thumbs = pane.querySelectorAll('.exp-thumb-item');
  
        swiperInstances[targetID] = new Swiper(swiperEl, {
          loop: false, speed: 400, spaceBetween: 20,
          on: {
            slideChange: function () {
              thumbs.forEach(t => t.classList.remove('is-active'));
              if (thumbs[this.activeIndex]) {
                thumbs[this.activeIndex].classList.add('is-active');
                thumbs[this.activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
              pane.querySelectorAll('video').forEach(v => v.pause());
              const activeSlide = this.slides[this.activeIndex];
              if(activeSlide) {
                const activeVideo = activeSlide.querySelector('video');
                if (activeVideo) activeVideo.play();
              }
            }
          }
        });
  
        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => { swiperInstances[targetID].slideTo(index); });
        });
      });
  
      const switchTab = (targetID) => {
        panes.forEach(pane => {
          if (pane.id === `exp-pane-${targetID}`) {
            pane.classList.add('is-active');
            if(swiperInstances[targetID]) swiperInstances[targetID].update();
          } else {
            pane.classList.remove('is-active');
            pane.querySelectorAll('video').forEach(v => v.pause());
          }
        });
        explorerOverlay.querySelectorAll('.exp-tab-btn').forEach(btn => {
          if (btn.getAttribute('data-exp-link') === targetID) btn.classList.add('is-active');
          else btn.classList.remove('is-active');
        });
      };
  
      triggerBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          switchTab(btn.getAttribute('data-exp-target'));
          explorerOverlay.classList.add('is-active');
          document.body.style.overflow = 'hidden'; 
        });
      });
  
      navLinks.forEach(link => {
        link.addEventListener('click', () => { switchTab(link.getAttribute('data-exp-link')); });
      });
  
      const closeExplorer = () => {
        explorerOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
        explorerOverlay.querySelectorAll('video').forEach(v => v.pause());
      };
  
      if (closeBtn) closeBtn.addEventListener('click', closeExplorer);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && explorerOverlay.classList.contains('is-active')) { closeExplorer(); }
      });
    }
  
    // =======================================================
    // 2. Main Buy Button (Fetch AJAX)
    // =======================================================
    const atcButtons = document.querySelectorAll('.custom-ajax-atc');
    atcButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); 
        const button = this;
        
        // 🎯 优化：优先从官方 variant-picker 获取选中的变体 ID
        const officialInput = document.querySelector('variant-picker input[name="id"]');
        const productId = officialInput ? officialInput.value : button.getAttribute('data-product-id');
        
        const textSpan = button.querySelector('.atc-text');
        const loadingSpan = button.querySelector('.atc-loading');
        
        button.disabled = true;
        if(textSpan) textSpan.style.display = 'none';
        if(loadingSpan) loadingSpan.style.display = 'inline-block';
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: productId, quantity: 1 }] })
        })
        .then(response => {
          if (!response.ok) throw new Error('Network Error');
          return response.json(); 
        })
        .then(data => {
          button.disabled = false;
          if(textSpan) textSpan.style.display = 'inline-block';
          if(loadingSpan) loadingSpan.style.display = 'none';
          
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
            else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
            else { cartDrawer.setAttribute('open', ''); }
          } else {
            const cartIcon = document.querySelector('a[href="/cart"], a[href="' + window.Shopify.routes.root + 'cart"]');
            if (cartIcon) { cartIcon.click(); } else { window.location.href = window.Shopify.routes.root + 'cart'; }
          }
        })
        .catch(error => {
          console.error('ATC Failed:', error);
          alert("Failed to add item. Please try again.");
          button.disabled = false;
          if(textSpan) textSpan.style.display = 'inline-block';
          if(loadingSpan) loadingSpan.style.display = 'none';
        });
      });
    });
  
    // =======================================================
    // 3. Bundles 2.0 & Extend Protection (jQuery Dependent)
    // =======================================================
    if (typeof jQuery !== 'undefined') {
      $(document).ready(function() {
        
        // Bundles Swatches Selection
        $(document).on('click', '.bundle-swatch-btn', function() {
          var $btn = $(this);
          var $itemContainer = $btn.closest('.product_info_bundles_item');
          var $swatchWrapper = $btn.closest('.bundle-swatch-wrapper');
          
          $swatchWrapper.find('.bundle-swatch-btn').removeClass('is-active');
          $btn.addClass('is-active');
          
          var variantTitle = $btn.data('variant-title');
          $swatchWrapper.find('.bundle-swatch-value').text(variantTitle);
          $itemContainer.find('.product_info_bundles_item_price').text($btn.data('variant-price'));
          $itemContainer.removeClass('product_info_bundles_item_act');
  
          var newImageSrc = $btn.data('variant-image');
          if (newImageSrc) {
            var $imageEl = $itemContainer.find('.product_info_bundles_item_images img');
            $imageEl.css('opacity', '0.5'); 
            setTimeout(function() {
              $imageEl.attr('src', newImageSrc);
              $imageEl.css('opacity', '1');
            }, 100); 
          }

          // 🎯 新增：读取后台设置开关，联动主画廊同步切换
          var isSyncEnabled = $itemContainer.closest('.product_info_bundles_op_b2').data('gallery-sync');
          
          if ((isSyncEnabled === true || isSyncEnabled === 'true') && variantTitle) {
            var searchStr = variantTitle.toLowerCase().replace(/\s+/g, '_'); 
            var fallbackStr = variantTitle.toLowerCase().replace(/\s+/g, '-'); 
            
            // 如果存在新版全局画廊
            if (window.pdpMainSwiper) {
              var $gallerySlides = $('.main-swiper .swiper-slide');
              var matchedIndex = -1;
              $gallerySlides.each(function() {
                var src = $(this).attr('data-media-src') || "";
                if (src.includes(searchStr) || src.includes(fallbackStr)) {
                  matchedIndex = $(this).data('index');
                  return false;
                }
              });
              if (matchedIndex !== -1) {
                window.pdpMainSwiper.slideTo(matchedIndex);
              }
            } 
            // 否则尝试适配旧版原声画廊
            else {
              var $nativeThumbnails = $('.product-gallery__thumbnail');
              if ($nativeThumbnails.length > 0) {
                $nativeThumbnails.each(function() {
                  var src = $(this).attr('data-media-src') || "";
                  if (src.includes(searchStr) || src.includes(fallbackStr)) {
                    $(this).click(); 
                    return false;
                  }
                });
              }
            }
          }
        });
  
        // Bundles ATC Click
        $(document).on('click', '.product_info_bundles_item_add2', function(e) {
          e.preventDefault();
          var $btn = $(this);
          var $currentParent = $btn.closest('.product_info_bundles_item');
          var $activeSwatch = $currentParent.find('.bundle-swatch-btn.is-active');
          var targetVariantId = $activeSwatch.length > 0 ? String($activeSwatch.data('variant-id')) : String($btn.attr("data-default-id"));
          
          $btn.css('pointer-events', 'none');
          
          if ($currentParent.hasClass("product_info_bundles_item_act")) {
            $.ajax({
              type: 'GET', url: window.Shopify.routes.root + 'cart.js', dataType: 'json',
              success: function(cart) {
                var currentItem = cart.items.find(item => String(item.variant_id) === targetVariantId || String(item.id) === targetVariantId);
                var newQty = currentItem && currentItem.quantity > 0 ? currentItem.quantity - 1 : 0;
                $.ajax({
                  type: 'POST', url: window.Shopify.routes.root + 'cart/change.js',
                  data: JSON.stringify({ id: targetVariantId, quantity: newQty }),
                  dataType: 'json', contentType: 'application/json',
                  success: function() {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                      else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
                      else { cartDrawer.setAttribute('open', ''); }
                    }
                    $currentParent.removeClass("product_info_bundles_item_act");
                    $btn.css('pointer-events', 'auto');
                  },
                  error: function() { $btn.css('pointer-events', 'auto'); }
                });
              },
              error: function() { $btn.css('pointer-events', 'auto'); }
            });
          } else {
            $.ajax({
              type: 'POST', url: window.Shopify.routes.root + 'cart/add.js',
              data: JSON.stringify({ 'items': [{ 'id': targetVariantId, 'quantity': 1 }] }),
              dataType: 'json', contentType: 'application/json',
              success: function() {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                  else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
                  else { cartDrawer.setAttribute('open', ''); }
                } else {
                  const cartIcon = document.querySelector('a[href="/cart"], a[href="' + window.Shopify.routes.root + 'cart"]');
                  if (cartIcon) { cartIcon.click(); } else { window.location.href = window.Shopify.routes.root + 'cart'; }
                }
                $currentParent.addClass("product_info_bundles_item_act");
                $btn.css('pointer-events', 'auto');
              },
              error: function(err) {
                alert('Failed to add item to cart.');
                $btn.css('pointer-events', 'auto');
              }
            });
          }
        });
  
        // Extend Protection ATC Click
        $(document).on('click', '.extend-protection-add-btn', function(e) {
          e.preventDefault();
          var $btn = $(this);
          var blockId = $btn.data('block-id');
          var id = $('input[name="warranty_variant_' + blockId + '"]:checked').val();
          
          if (!id) return;
          $btn.css('pointer-events', 'none');
          var originalText = $btn.find('.ep-btn-text').text();
          $btn.find('.ep-btn-text').text('Adding...');
    
          // 同样优化：延保也优先找 variant-picker 获取商品真实选中的 SKU
          var currentSku = String($btn.data('fallback-sku'));
          var officialSkuElement = document.querySelector('variant-sku');
          if (officialSkuElement && officialSkuElement.textContent.trim() !== '') {
            currentSku = officialSkuElement.textContent.replace('SKU:', '').trim();
          } else {
             var $skuElement = $('variant-sku'); 
             if ($skuElement.length && $skuElement.text().trim() !== '') {
                currentSku = $skuElement.text().replace('SKU:', '').trim();
             }
          }
    
          $.ajax({
            type: 'POST', url: window.Shopify.routes.root + 'cart/add.js',
            data: JSON.stringify({
              'items': [{ 'id': id, 'quantity': 1, 'properties': { 'Main_Product_SKU': currentSku } }]
            }),
            dataType: 'json', contentType: 'application/json',
            success: function() {
              $btn.find('.ep-btn-text').text('Added!');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
              }
              setTimeout(function() {
                $btn.find('.ep-btn-text').text(originalText);
                $btn.css('pointer-events', 'auto');
              }, 2000);
            },
            error: function(err) {
              alert('Failed to add item to cart.');
              $btn.find('.ep-btn-text').text(originalText);
              $btn.css('pointer-events', 'auto');
            }
          });
        });
  
      });
    }
  });
  // =======================================================
  // 4. Custom Variant Picker Logic
  // =======================================================
  class CustomVariantSelector extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      // 预加载变体 JSON
      const jsonEl = this.querySelector('.variant-json');
      this.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      this.masterInput = document.querySelector('.js-master-variant-input');
    }

    onVariantChange(event) {
      // 1. 获取当前选中的所有 option 值
      this.options = Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });

      // 2. 更新上方提示文字
      const currentFieldset = event.target.closest('fieldset');
      const selectedValueNode = currentFieldset.querySelector('.js-selected-value');
      if(selectedValueNode) selectedValueNode.textContent = event.target.value;

      // 3. 在 JSON 中匹配真实 Variant ID
      this.currentVariant = this.variantData.find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });

      if (!this.currentVariant) return;

      // 4. 更新隐藏的 master ID (给 Ajax ATC 加购按钮使用)
      if(this.masterInput) this.masterInput.value = this.currentVariant.id;

      // 5. 更新浏览器 URL (可选，为了分享链接精准定位)
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

      // 6. 联动更新价格显示
      const priceWrapper = document.querySelector('.price-current');
      if (priceWrapper) {
        // Shopify 返回的价格是分，需格式化
        const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        priceWrapper.textContent = formatter.format(this.currentVariant.price / 100);
      }

      // 7. 联动主画廊 (V2 Swiper 同步)
      if (this.currentVariant.featured_image && window.pdpMainSwiper) {
        // 将 featured_image 的 src 转小写，适配我们之前在 swiper-slide 上加的 data-media-src
        const searchSrc = this.currentVariant.featured_image.src.toLowerCase();
        const $gallerySlides = $('.main-swiper .swiper-slide');
        let matchedIndex = -1;
        
        $gallerySlides.each(function() {
          const slideSrc = $(this).attr('data-media-src') || "";
          if (slideSrc && searchSrc.includes(slideSrc.split('?')[0])) {
            matchedIndex = $(this).data('index');
            return false;
          }
        });
        
        if (matchedIndex !== -1) {
          window.pdpMainSwiper.slideTo(matchedIndex);
        } else {
          // 如果 V2 没找到，尝试触发原生 Impact 画廊的小图点击
          const $nativeThumbnails = $('.product-gallery__thumbnail');
          $nativeThumbnails.each(function() {
            const thumbSrc = $(this).attr('data-media-src') || "";
            if (thumbSrc && searchSrc.includes(thumbSrc.split('?')[0])) {
              $(this).click();
              return false;
            }
          });
        }
      }
    }
  }
  
  // 注册 Web Component
  customElements.define('variant-selector', CustomVariantSelector);